import { Brand, createBranded } from '@deltasierra/type-utilities';
import { HasId, Auditable } from '../common';
import { LocationId } from '../location';
import { PublishedArtifactId } from '../publishedArtifact';
import { PrintProviderId } from './PrintProvider';

export type PrintProviderStatsId = Brand<number, 'PrintProviderStatsId'>;
export const PrintProviderStatsId = createBranded<PrintProviderStatsId>();

export interface PrintProviderStats extends HasId<PrintProviderStatsId>, Auditable {
    locationId: LocationId;
    previewed: boolean;
    // PrintProvider?: PrintProvider;
    printProviderId: PrintProviderId | null;
    // PublishedArtifact?: PublishedArtifact;
    publishedArtifactId: PublishedArtifactId | null;
    quantity: number;
    instructions: string | null;
    documentPagesAmount: number | null;
    formatWidth: number | null;
    formatHeight: number | null;
}
